type SeverityLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';

export const captureException = (
	error: Error,
	context?: Record<string, unknown>,
) => {
	void error;
	void context;
};

export const addBreadcrumb = (
	message: string,
	category = 'custom',
	level: SeverityLevel = 'info',
) => {
	void message;
	void category;
	void level;
};

export const setUserContext = (user: {
	id?: string;
	email?: string;
	username?: string;
}) => {
	void user;
};

export const clearUserContext = () => {};
